module.exports = __webpack_public_path__ + "nc_static/media/filter_kpi.063c47ba.svg";